module.exports = __webpack_public_path__ + "static/media/icon-manual-dial.d5b2a963.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/WorkBar/icon-manual-dial.svg
// module id = 1866
// module chunks = 0